import NotFound from "../pages/NotFound";
import OwnerRegister from "../pages/owner/auth/OwnerRegister";
import OwnerHomePage from "../pages/owner/home/OwnerHomePage";
import StoreProductsOverView from "../pages/store/products/StoreProductsOverView";
import AddProduct from "../pages/store/products/AddProduct";
import AddExtraItems from "../pages/store/products/AddProductExtraItems";
import AddProductInstructions from "../pages/store/products/AddProductInstructions";
import AddProductVariants from "../pages/store/products/AddProductVariant";
import ProductDetailsPage from "../pages/store/products/ProductDetailsPage";
import UpdateProduct from "../pages/store/products/UpdateProduct";
import StoreOffersOverView from "../pages/store/offers/StoreOffersOverView";
import AddOfferPage from "../pages/store/offers/CreateOfferPage";
import StoreOrdersOverView from "../pages/store/orders/StoreOrdersOverView";
import OwnerSendOtp from "../pages/owner/auth/SendOtp";
import OwnerVerifyOtp from "../pages/owner/auth/VerifyOtp";
import ProtectedRouteOwner from "./ProtectedRouteOwner";
import PublicRouteOwner from "./PublicRouteOwner";
import OnwerViewAllStores from "../pages/owner/store/OwnerViewAllStores";
import StorePageOne from "../pages/owner/store/CreateStorePageOne";
import StorePageTwo from "../pages/owner/store/CreateStorePageTwo";
import StorePageThree from "../pages/owner/store/CreateStorePageThree";
import StorePageFour from "../pages/owner/store/CreateStorePageFour";
import StoreFormFive from "../pages/owner/store/CreateStorePageFive";
import CreateCategoryPage from "../pages/store/category/CreateCategoryPage";
import StoreLogin from "../pages/store/auth/StoreLogin";
import OrderDetailsPage from "../pages/store/orders/OrderDetailsPage";
import StoreReviewOverView from "../pages/store/review/StoreReviewOverView";
import UpdateStore from "../pages/store/updatePages.tsx/UpdateStore";
import StoreBasicPage from "../pages/owner/store/CreateStoreBasicPage";
import OwnerUpdate from "../pages/owner/auth/UpdateOwner";
import StoreOverviewTransactions from "../pages/store/transactions/StoreOverviewTransactions";
import ProtectedRouteCustomer from "./ProtectCustomerRoute";
import CustomerSendOtp from "../pages/customer/auth/SendOtpCustomer";
import CustomerVerifyOtp from "../pages/customer/auth/VerifyOtpCustomer";
import DeleteAccountPageCustomer from "../pages/customer/auth/DeleteAccount";
import PrivacyPloicy from "../pages/PrivacyPloicy";
import AdminLoginPage from "../pages/admin/auth/AdminLoginPage";
import AdminHomePage from "../pages/admin/home/AdminHomePage";
import PublicRouteAdmin from "./PublicRouteAdmin";
import ProtectedRouteAdmin from "./ProtectedAdminRoute";
import AdminViewAllCarBrandsPage from "../pages/admin/carBrand/AdminViewAllCarBrandsPage";
import AdminAddCarBrandPage from "../pages/admin/carBrand/AdminAddCarBrandPage";
import AdminViewAllStoreTypesPage from "../pages/admin/storeTypes/AdminViewAllStoreTypesPage";
import AdminAddStoreType from "../pages/admin/storeTypes/AdminAddStoreType";
import AdminViewStoreSubTypesPage from "../pages/admin/storeSubTypes/AdminViewStoreSubTypesPage";
import AddStoreSubType from "../pages/admin/storeSubTypes/AddStoreSubType";
import AdminViewAllAvatarsPage from "../pages/admin/avatars/AdminViewAllAvatarsPage";
import AdminAddAvatarPage from "../pages/admin/avatars/AdminAddAvatarPage";
import AdminViewSectorsPage from "../pages/admin/sectors/AdminViewAllSectorsPage";
import AdminAddSectorPage from "../pages/admin/sectors/AdminAddSectorPage";
import AdminViewGiftCategoriesPage from "../pages/admin/giftCategories/AdminViewGiftCategories";
import AdminAddGiftCategoryPage from "../pages/admin/giftCategories/AdminAddGiftCategoryPage";
import AdminViewGiftTemplatesPage from "../pages/admin/giftTemplates/AdminViewGiftTemplates";
import AdminAddGiftTemplatePage from "../pages/admin/giftTemplates/AdminAddGiftTemplate";
import AdminViewVariantCategoriesPage from "../pages/admin/varaintCategories/AdminViewVariantCategoriesPage";
import AdminAddVariantCategoryPage from "../pages/admin/varaintCategories/AdminAddVariantCategoryPage";
import AdmiinViewLoyaltyOffersPage from "../pages/admin/loyaltyOffers/AdmiinViewLoyaltyOffersPage";
import AdminAddLoyaltyOfferPage from "../pages/admin/loyaltyOffers/AdminAddLoyaltyOfferPage";
import AdminViewCoupouns from "../pages/admin/coupouns/AdminViewCoupouns";
import AdminAddCoupounPage from "../pages/admin/coupouns/AdminAddCopounPage";
import AdminViewStoresPage from "../pages/admin/stores/AdminViewStoresPage";
import StoreDetailsForAdminPage from "../pages/admin/stores/StoreDetailsForAdminPage";
import StoreCategoriesOverView from "../pages/store/category/StoreCategoriesOverView";
import AdminViewOwnersPage from "../pages/admin/owners/AdminViewOwnersPage";
import OnwerDetailsPageForAdmin from "../pages/admin/owners/OnweDetailsPageForAdmin";
import PointsSystemAdminPage from "../pages/admin/points/PointsSystemAdminPage";
import AdminSendOtp from "../pages/admin/auth/AdminSendOptPage";
import AdminVerifyOtp from "../pages/admin/auth/AdminVerifyOtp";
import AdminViewRolesPage from "../pages/admin/roles/AdminViewRolesPage";
import AdminAddRole from "../pages/admin/roles/AdminAddRole";
import AdminUpdateRole from "../pages/admin/roles/AdminUpdateRole";
import AdminViewEmployees from "../pages/admin/employees/AdminViewEmployees";
import AdminAddNewEmployee from "../pages/admin/employees/AdminAddNewEmployee";
import RoleDetailsPage from "../pages/admin/roles/RoleDetailsPage";
import { PermissionGate } from "../components/admin/PermissionGate";
import { PermissionsKey } from "../data/permissions";
import AdminViewCustomersPage from "../pages/admin/customers/AdminViewCustomersPage";
import CustomerDetailsPage from "../pages/admin/customers/CustomerDetailsPageForAdmin";
import TicketsListPage from "../pages/store/tickets/TicketsStoreListPage";
import TicketDetailPage from "../pages/store/tickets/TicketDetailPage";
import CreateTicketPage from "../pages/store/tickets/CreateTicketPage";
import ContactInfoPage from "../pages/admin/contactSystem/ContactInfoPage";
import SiteContentPage from "../pages/admin/siteContent/SiteContentPage";

export const routes = [
  //  opt code pages
  { path: "/", element:<PublicRouteOwner><OwnerSendOtp/></PublicRouteOwner> },
  { path: "/verify-otp",element:<><OwnerVerifyOtp/></> },
  { path: "/owner/profile-setup",element: <><OwnerRegister/> </>},
  { path: "/owner/settings",element: <ProtectedRouteOwner><OwnerUpdate/> </ProtectedRouteOwner>},
  { path: "*" , element: <NotFound />},

  // store login page
    { path: "/store/login",element:<PublicRouteOwner redirect="/store/settings"><StoreLogin/></PublicRouteOwner> },


  // owner and store routes
  { path: "/store/dashboard", element: <ProtectedRouteOwner requireStore><OwnerHomePage/></ProtectedRouteOwner>},



  // products store page
  { path: "/store/products", element:<ProtectedRouteOwner requireStore><StoreProductsOverView/></ProtectedRouteOwner> },
  { path: "/store/products/:productId", element: <ProductDetailsPage/> },
  { path: "/store/products/add-product", element: <ProtectedRouteOwner requireStore><AddProduct/></ProtectedRouteOwner> },
  { path: "/store/update-product/:productId", element: <ProtectedRouteOwner requireStore><UpdateProduct/></ProtectedRouteOwner> },
  { path: "/store/products/:productId/extra-items", element:<ProtectedRouteOwner requireStore><AddExtraItems/> </ProtectedRouteOwner>},
  { path: "/store/products/:productId/instructions", element: <ProtectedRouteOwner requireStore><AddProductInstructions/></ProtectedRouteOwner> },
  { path: "/store/products/:productId/variants", element: <ProtectedRouteOwner requireStore><AddProductVariants/></ProtectedRouteOwner> },
  

  //  offers pages for store
  { path: "/store/offers", element: <ProtectedRouteOwner requireStore><StoreOffersOverView/></ProtectedRouteOwner> },
  { path: "/store/offers/add-offer", element: <ProtectedRouteOwner requireStore><AddOfferPage/></ProtectedRouteOwner> },

    // orders pages  for store
    { path: "/store/orders", element: <ProtectedRouteOwner requireStore><StoreOrdersOverView/></ProtectedRouteOwner> },
    { path: "/store/orders/:orderId", element: <ProtectedRouteOwner requireStore><OrderDetailsPage/></ProtectedRouteOwner> },

    // transactions pages for store
    { path: "/store/transactions", element: <ProtectedRouteOwner requireStore><StoreOverviewTransactions/></ProtectedRouteOwner> },

    // store reviews page
    {path:"/store/reviews" ,element:<ProtectedRouteOwner requireStore><StoreReviewOverView/></ProtectedRouteOwner>},

    // store settings
    // {path:"/store/settings/:storeId" ,element:<ProtectedRouteOwner><UpdateStore/></ProtectedRouteOwner>},

    {path:"/store/settings" ,element:<ProtectedRouteOwner redirectLink="/store/login?redirect=/store/settings"><UpdateStore/></ProtectedRouteOwner>},



    // stores for owner
    {path:"/owner/stores",element:<ProtectedRouteOwner ownerOnly><OnwerViewAllStores/> </ProtectedRouteOwner>},
    {path:"/owner/add-store",element:<ProtectedRouteOwner ownerOnly><StoreBasicPage/> </ProtectedRouteOwner>},
    {path:"/owner/add-store/page1",element:<ProtectedRouteOwner ownerOnly><StorePageOne/> </ProtectedRouteOwner>},
    {path:"/owner/add-store/page2",element:<ProtectedRouteOwner ownerOnly><StorePageTwo/> </ProtectedRouteOwner>},
    {path:"/owner/add-store/page3",element:<ProtectedRouteOwner ownerOnly><StorePageThree/> </ProtectedRouteOwner>},
    {path:"/owner/add-store/page4",element:<ProtectedRouteOwner ownerOnly><StorePageFour/> </ProtectedRouteOwner>},
    {path:"/owner/add-store/page5",element:<ProtectedRouteOwner ownerOnly><StoreFormFive/> </ProtectedRouteOwner>},

    // catgories pages for store
    {path:"/store/categories" ,element :<ProtectedRouteOwner requireStore><StoreCategoriesOverView/></ProtectedRouteOwner>},
    {path:"/store/add-category" ,element :<ProtectedRouteOwner requireStore><CreateCategoryPage/></ProtectedRouteOwner>},

    // tickets pages for store
    {path:"/store/tickets" ,element :<ProtectedRouteOwner requireStore><TicketsListPage/></ProtectedRouteOwner>},
    {path:"/store/tickets/:ticketId" ,element :<ProtectedRouteOwner requireStore><TicketDetailPage/></ProtectedRouteOwner>},
     {path:"/store/add-ticket" ,element :<ProtectedRouteOwner requireStore><CreateTicketPage/></ProtectedRouteOwner>},


    // customer pages
    {path:"/customer/delete-account" ,element :<ProtectedRouteCustomer><DeleteAccountPageCustomer/></ProtectedRouteCustomer>},
    {path:"/customer/sendOtp" , element:<CustomerSendOtp/>},
    {path:"/customer/verify-otp" , element:<CustomerVerifyOtp/>},

    // privacy policy
    {path:"/privacy-policy" , element:<PrivacyPloicy/>},

    // admin pages 
      // admin login
      {path:"/admin/login" , element:<><AdminLoginPage/></>},
      {path:"/admin/send-otp" , element:<><AdminSendOtp/></>},
      {path:"/admin/verify-otp" , element:<><AdminVerifyOtp/></>},
      // admin home page
      {path:"/admin" , element:<ProtectedRouteAdmin><AdminHomePage/></ProtectedRouteAdmin>},
      // adnmin car beand pages
      {path:"/admin/car-brands" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewCarBrand]}><AdminViewAllCarBrandsPage/></PermissionGate>
        </ProtectedRouteAdmin>
      },
      {path:"/admin/add-carBrand" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateCarBrand]}>
          <AdminAddCarBrandPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>} ,
      // admin store types page
      {path:"/admin/store-types" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewTypeOfStore]}>
          <AdminViewAllStoreTypesPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>} ,
      {path:"/admin/add-storeType" , element:<ProtectedRouteAdmin>
        <PermissionGate permissions={[PermissionsKey.CreateTypeOfStore]}>
          <AdminAddStoreType/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // admin store sub types pages
      {path:"/admin/subTypes/:typeId" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewTypeOfStore]}>
          <AdminViewStoreSubTypesPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-subType/:typeId" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateTypeOfStore]}>
          <AddStoreSubType/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      //  admin avatars pages
      {path:"/admin/avatars" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewAvatar]}>
          <AdminViewAllAvatarsPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-avatar" , element:<ProtectedRouteAdmin>
        <PermissionGate permissions={[PermissionsKey.CreateAvatar]}>
          <AdminAddAvatarPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      
      // admin sectors pages
      {path:"/admin/sectors" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewSector]}>
          <AdminViewSectorsPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-sector" , element:<ProtectedRouteAdmin>
        <PermissionGate permissions={[PermissionsKey.CreateSector]}>
          <AdminAddSectorPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // admin gift categories
      {path:"/admin/gift-categories" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewGiftCategory]}>
          <AdminViewGiftCategoriesPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-giftCategory" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateGiftCategory]}>
          <AdminAddGiftCategoryPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
        //  gift templates for admin
          {path:"/admin/gift-templates/:giftCategoryId" , element:<ProtectedRouteAdmin>
            <PermissionGate isPage permissions={[PermissionsKey.ViewGiftCategory]}>
              <AdminViewGiftTemplatesPage/>
            </PermissionGate>
          </ProtectedRouteAdmin>},
          {path:"/admin/add-giftTemplate/:giftCategoryId" , element:<ProtectedRouteAdmin>
            <PermissionGate isPage permissions={[PermissionsKey.CreateGiftCategory]}>
              <AdminAddGiftTemplatePage/>
            </PermissionGate>
          </ProtectedRouteAdmin>},

      // admin variants categories pages
      {path:"/admin/variant-categories" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewVariantCategory]}>
          <AdminViewVariantCategoriesPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-variantCategory" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateVariantCategory]}>
          <AdminAddVariantCategoryPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},


      // loyalty offers pages for admin
      {path:"/admin/loyalty-offers" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewLoyaltyOffer]}>
          <AdmiinViewLoyaltyOffersPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-loyaltyOfferr" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateLoyaltyOffer]}>
          <AdminAddLoyaltyOfferPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // coupouns page for admin 
      {path:"/admin/coupouns" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewCoupon]}>
          <AdminViewCoupouns/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-coupoun" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateCoupon]}>
          <AdminAddCoupounPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // stores pages for admin
      {path:"/admin/stores" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewStores]}>
          <AdminViewStoresPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/stores/:storeId" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewStores]}>
          <StoreDetailsForAdminPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/stores/:storeId/settings" ,element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.UpdateStore]}>
          <UpdateStore/>
        </PermissionGate>
      </ProtectedRouteAdmin>},


      // admin products store pages
      {path:"/admin/stores/:storeId/products" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewProduct]}>
          <StoreProductsOverView/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/stores/:storeId/add-product" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateProduct]}>
          <AddProduct/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      { path: "/admin/stores/:storeId/update-product/:productId", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.UpdateProduct]}>
          <UpdateProduct/>
        </PermissionGate>
      </ProtectedRouteAdmin> },
      { path: "/admin/stores/:storeId/products/:productId/extra-items", element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.UpdateProduct, PermissionsKey.CreateProduct]}>
          <AddExtraItems/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      { path: "/admin/stores/:storeId/products/:productId/instructions", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateProduct , PermissionsKey.UpdateProduct]}>
          <AddProductInstructions/>
        </PermissionGate>
      </ProtectedRouteAdmin> },
      { path: "/admin/stores/:storeId/products/:productId/variants", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.UpdateProduct , PermissionsKey.CreateProduct]}>
          <AddProductVariants/>
        </PermissionGate>
      </ProtectedRouteAdmin> },
      { path: "/admin/stores/:storeId/products/:productId", element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewProduct]}>
          <ProductDetailsPage/>
        </PermissionGate>
      </ProtectedRouteAdmin> },

      // admin add catgeory for store products
      {path:"/admin/stores/:storeId/categories" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewStoreCategory]}>
          <StoreCategoriesOverView/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/stores/:storeId/add-category" , element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStoreCategory]}>
          <CreateCategoryPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // admin offers pages for store
  { path: "/admin/stores/:storeId/offers", element: <ProtectedRouteAdmin>
    <PermissionGate isPage permissions={[PermissionsKey.ViewOffer]}>
      <StoreOffersOverView/>
    </PermissionGate>
  </ProtectedRouteAdmin> },
  { path: "/admin/stores/:storeId/offers/add-offer", element: <ProtectedRouteAdmin>
    <PermissionGate isPage permissions={[PermissionsKey.CreateOffer]}>
      <AddOfferPage/>
    </PermissionGate>
  </ProtectedRouteAdmin> },

  // admin reviews pages for store
  {path:"/admin/stores/:storeId/reviews" ,element:<ProtectedRouteAdmin>
    <PermissionGate isPage permissions={[PermissionsKey.ViewStoreReviews]}>
      <StoreReviewOverView/>
    </PermissionGate>
  </ProtectedRouteAdmin>},

  // admin transactions for store
    { path: "/admin/stores/:storeId/transactions", element: <ProtectedRouteAdmin>
      <PermissionGate isPage permissions={[PermissionsKey.ViewStoreTransactions]}>
        <StoreOverviewTransactions/>
      </PermissionGate>
    </ProtectedRouteAdmin> },


        //admin orders pages  for store
    { path: "/admin/stores/:storeId/orders", element: <ProtectedRouteAdmin>
      <PermissionGate isPage permissions={[PermissionsKey.ViewStoreOrders]}>
        <StoreOrdersOverView/>
      </PermissionGate>
    </ProtectedRouteAdmin> },
    { path: "/admin/stores/:storeId/orders/:orderId", element: <ProtectedRouteAdmin>
      <PermissionGate isPage permissions={[PermissionsKey.ViewStoreOrders]}>
        <OrderDetailsPage/>
      </PermissionGate>
    </ProtectedRouteAdmin> },

    //  store statistics pages
      { path: "/admin/stores/:storeId/statistics", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewStoreStats]}>
          <OwnerHomePage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // owenrs pages for admin
      { path: "/admin/owners", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewOwners]}>
          <AdminViewOwnersPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      { path: "/admin/owners/:ownerId", element: <ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewOwners]}>
          <OnwerDetailsPageForAdmin/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StoreBasicPage/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store/page1",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StorePageOne/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store/page2",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StorePageTwo/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store/page3",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StorePageThree/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store/page4",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StorePageFour/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/owners/:ownerId/add-store/page5",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateStore]}>
          <StoreFormFive/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

       // points pages 
      {path:"/admin/points",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.SystemPoints]}>
          <PointsSystemAdminPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // contact info for admin 
      {path:"/admin/contact-info",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.SystemSettings]}>
          <ContactInfoPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},


       // roles pages for admin
      {path:"/admin/roles",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.viewRole]}>
          <AdminViewRolesPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/roles/:roleId",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.viewRole]}>
          <RoleDetailsPage/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-role",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateRole]}>
          <AdminAddRole/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/roles/:roleId/update",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.UpdateRole]}>
          <AdminUpdateRole/>
        </PermissionGate>
      </ProtectedRouteAdmin>},


      //  employees pages for admin
      {path:"/admin/employees",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewAdmin]}>
          <AdminViewEmployees/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
      {path:"/admin/add-employee",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.CreateAdmin]}>
          <AdminAddNewEmployee/> 
        </PermissionGate>
      </ProtectedRouteAdmin>},

      // customers pages for admin
      {path:"/admin/customers",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewCustomer]}>
          <AdminViewCustomersPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},
       {path:"/admin/customers/:customerId",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.ViewCustomer]}>
          <CustomerDetailsPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>},


//   site content manage page
    {path:"/admin/site-content",element:<ProtectedRouteAdmin>
        <PermissionGate isPage permissions={[PermissionsKey.LandingPage]}>
          <SiteContentPage/>
        </PermissionGate>
      </ProtectedRouteAdmin>}
];